export default {
  // 本地环境
  // webTopWindowUri: 'http://localhost:8800',
  // 测试环境
  webTopWindowUri: 'https://01.singamlottery.com',
  // 生产环境
  // webTopWindowUri: 'https://singamlottery.com',
};
